import { render, staticRenderFns } from "./formTwitter.vue?vue&type=template&id=3efb0e1a"
import script from "./formTwitter.vue?vue&type=script&lang=js"
export * from "./formTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efb0e1a')) {
      api.createRecord('3efb0e1a', component.options)
    } else {
      api.reload('3efb0e1a', component.options)
    }
    module.hot.accept("./formTwitter.vue?vue&type=template&id=3efb0e1a", function () {
      api.rerender('3efb0e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formTwitter.vue"
export default component.exports